/**
 * Label for PostModal's review-mode Approve CTA. Names the platform count when
 * the approval commits more than one platform, so the button reads exactly
 * what will publish ("Approve 2 platforms · Sep 8, 5:00 PM"), the same way the
 * multi-platform Post-now CTA does. A single platform keeps the short form.
 */
export function approveCtaLabel(platformCount: number, scheduleSummary: string): string {
  const scope = platformCount > 1 ? ` ${platformCount} platforms` : ''
  return `Approve${scope} · ${scheduleSummary}`
}
